<template>
    <div class="pop_overay">
        <div class="pop_cont">
            <img @click="closeBtn" class="close_icon_admin" src="@/assets/images/close.png" alt="close">
            <img class="icon_img" src="@/assets/images/popup_icon.png" alt="icon">
            <div class="text_2">
                <div class="noti_txt">
                  <div>
                    <b>[리뷰 작성하러 가기]</b><br/><br/>
                    투어는 만족스러우셨나요?<br/>
                    스토어 별점을 남겨주세요!<br/><br/>
                    작성해주신 리뷰가 저희에게<br/>큰 힘이 됩니다.
                  </div>
                </div>
            </div>
            <button @click="starPoint">리뷰 남기기</button>
        </div>
    </div>
</template>
<script>
import * as appEvent from '@/assets/js/app_event.js'
export default {
  name: 'PopupStarPoint',
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    starPoint () {
      this.$cookie.set('writeStarPoint', 'Y', 180)
      appEvent.moveReview()
      this.closeBtn()
    },
    closeBtn () {
      this.$store.state.starPointPop = false
    }
  },
  mounted () {
  }
}
</script>
